import { loadable } from '@change-corgi/core/react/loadable';

import type { AppRoute } from 'src/shared/routes';

import { Loading } from 'src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'about',
		path: '/about',
		component: loadable(async () => import(/* webpackChunkName: "pages/about" */ './index'), {
			exportName: 'About',
			fallback: Loading,
		}),
		frame: true,
		ssr: {
			// switch this to true to enable SSR
			enabled: true,
			seo: true, // page should be indexable
			config: {
				disallowUserData: true,
				cache: {
					enabled: true,
					lifetimeInSeconds: 1 * 60 * 60, // 1 hour
				},
			},
		},
	},
];
